import Vue from 'vue'
import Vuex from "vuex"
Vue.use(Vuex);
//状态数据
const  state = {
  count : 1,
  user:{},
  token:''
};
//同步执行方法
const  mutations = {
  add:function (state) {
    state.count ++;
  },
  setUserInfo:function (state,userInfo) {
    state.user = userInfo;
  },
  setToken:function (state,token) {
    state.token = token;
  }
};
//异步执行方法
const  actions = {
  addAction:function (commit) {
    commit("add");
  },
  setUserInfo:function (commit,userInfo) {
    commit("setUserInfo",userInfo);
  },
  setToken:function (commit,token) {
    commit("setToken",token);
  }
};
//在获取值之前再次处理
const  getters = {
  countGetter:function (state) {
    return state.count += 100;
  }
};

export default new Vuex.Store({state:state,getters:getters,actions:actions,mutations:mutations});



// WEBPACK FOOTER //
// ./src/vuex/store.js